export default "__VITE_ASSET__Dp5WXv42__"